import { enResource } from './en';

export const resources = { en: { translation: { ...enResource } } };
